/* template */
<template><page><div :class='["switch-page"]'><base-container><div :class='["switch-example"]'><div :class='["switch-show"]'><cube-switch :value="valueOne" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","valueOne", "__mpx_event__", ["value"], undefined]])'></cube-switch><span :class='["switch-text"]'>Switch</span></div><div :class='["switch-value"]'>switch value: {{valueOne}}</div></div><div :class='["switch-example"]'><div :class='["switch-show"]'><cube-switch :value="valueTwo" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","valueTwo", "__mpx_event__", ["value"], undefined]])'></cube-switch><span :class='["switch-text"]'>Switch</span></div><div :class='["switch-value"]'>switch value: {{valueTwo}}</div></div><div :class='["switch-example"]'><div :class='["switch-show"]'><cube-switch :disabled="(true)" :value="(true)"></cube-switch><span :class='["switch-text"]'>Disabled Switch</span></div><div :class='["switch-value"]'>switch value: true</div></div><div :class='["switch-example"]'><div :class='["switch-show"]'><cube-switch @change='(e)=>__invoke(e, [["getValue"]])'></cube-switch><span :class='["switch-text"]'>Bindchange Switch</span></div><div :class='["switch-value"]'>switch value: {{currentValue}}</div></div><div :class='["switch-example"]'><div :class='["switch-show"]'><cube-switch :disabled="(true)" :value="(false)"></cube-switch><span :class='["switch-text"]'>Disabled Switch</span></div><div :class='["switch-value"]'>switch value: false</div></div></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_814e244c"}'>
.switch-page
  padding-top: 10px
  height 100%
  background-color rgba(239, 239, 244, .7)
  .switch-example
    .switch-show
      display: flex
      padding: 15px
      background-color: white
      .switch-text
        margin-left: 10px
    .switch-value
      margin: 10px 0
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_814e244c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_814e244c"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_814e244c"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-switch':getComponent(require("../../../packages/mpx-cube-ui/src/components/switch/index.mpx?isComponent&outputPath=components%2Findexd0fccf8a%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>